import BaseEndpoint from '@/api/endpoints/base-endpoint'

export default class RequestEndpoint extends BaseEndpoint {}
